import React from 'react';

const WhoWeServe = () => {
    return (
        <div className="w-full px-6 sm:px-12 md:px-16 lg:pl-20 lg:pr-12 relative pt-0 pb-8 min-h-[500px]">
            {/* Main heading */}
            <h1 className="text-left text-4xl md:text-5xl font-black text-[#5c3e21] mb-5 tracking-tight">
                Who we Serve
            </h1>
            
            {/* Subheading */}
            <p className="text-left text-xl md:text-2xl font-bold text-[#8c5021] mb-2">
                One platform – Four communities.
            </p>
            <p className="text-left text-gray-700 text-base md:text-lg mb-8 font-semibold">
                Smart Acharya serves students and parents, tutors, schools and tutoring centres, and corporates; 
                each with their own dedicated environment.
            </p>

            {/* Students & Parents */}
            <div className="mb-6">
                <h2 className="text-xl md:text-2xl font-bold text-[#8c5021] mb-2">
                    ❖ Students & Parents
                </h2>
                <p className="text-gray-800 text-sm sm:text-base lg:text-[17px] leading-relaxed">
                    Find the right verified Acharya for any subject, any stage and any ambition – from GCSE Maths to Bharatanatyam, 
                    from 11+ preparation to UCAS guidance. Learning for every stage of life.
                </p>
            </div>

            {/* Tutors */}
            <div className="mb-6">
                <h2 className="text-xl md:text-2xl font-bold text-[#8c5021] mb-2">
                    ❖ Tutors
                </h2>
                <p className="text-gray-800 text-sm sm:text-base lg:text-[17px] leading-relaxed">
                    Share your expertise, reach students across the UK and build a professional teaching practice on your own terms. 
                    From GCSE tutors to Bharatanatyam teachers, Smart Acharya gives every Acharya the platform, the tools and the students.
                </p>
            </div>

            {/* Schools & Tutoring Centres */}
            <div className="mb-6">
                <h2 className="text-xl md:text-2xl font-bold text-[#8c5021] mb-2">
                    ❖ Schools & Tutoring Centres
                </h2>
                <p className="text-gray-800 text-sm sm:text-base lg:text-[17px] leading-relaxed">
                    Your own secure, private platform environment, AI powered, built around your teachers, your content and your students. 
                    Elevate your outcomes without the technology headache.
                </p>
            </div>

            {/* Corporates & Organisations */}
            <div className="mb-6">
                <h2 className="text-xl md:text-2xl font-bold text-[#8c5021] mb-2">
                    ❖ Corporates & Organisations
                </h2>
                <p className="text-gray-800 text-sm sm:text-base lg:text-[17px] leading-relaxed">
                    Capture and scale what your best people know. An internal knowledge platform that makes your institutional expertise 
                    permanent, teachable and accessible on demand.
                </p>
            </div>
        </div>
    );
};

export default WhoWeServe;